import { render, staticRenderFns } from "./TransferDesignContent.vue?vue&type=template&id=d3d087fa"
import script from "./TransferDesignContent.vue?vue&type=script&lang=js"
export * from "./TransferDesignContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports